"use strict";

class SuperUsersMainViewController {

    constructor($scope, $parse, SSHttpService, SSUtilService, SSAppService, SSAlertService, OTPService, SSUserService) {
        const self = this;

        self.$scope = $scope;
        self.$parse = $parse;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSAlertService = SSAlertService;
        self.OTPService = OTPService;
        self.SSUserService = SSUserService;

        self.data = SHOWSUITE.data;

        if (self.SSUserService.isSuper()) {
            self.init();
        }
    }

    init() {
        const self = this;

    }
}

SuperUsersMainViewController.$inject = ['$scope', '$parse', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSAlertService', 'OTPService', 'SSUserService'];
app.controller('SuperUsersMainViewController', SuperUsersMainViewController);

